import { Component, Input, OnInit, Inject, Optional } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
@Component({
  selector: 'kt-success-schedulling',
  templateUrl: './success-schedulling.component.html',
  styleUrls: ['./success-schedulling.component.css']
})
export class SuccessSchedullingComponent implements OnInit {

  @Input() title: string;
  @Input() date: string;
  @Input() time: string;
  @Input() btnOkText:string = 'OK';
  @Input() btnCancelText: string = 'Cancel';
  constructor(private dialogRef: MatDialogRef<SuccessSchedullingComponent>,@Optional() @Inject(MAT_DIALOG_DATA) public data: any,) { }

  ngOnInit() {
    this.title = this.data.title;
    this.date = this.data.date;
    this.time = this.data.time;
  }

  public decline() {
    this.dialogRef.close(false);
  }

  public accept() {
    this.dialogRef.close(true);
  }

  public dismiss(type) {
    this.dialogRef.close(type);
  }

}
